import { makeAutoObservable } from 'mobx';
import { v4 as uuidv4 } from 'uuid';

import type { InlineNotificationVariant } from '~/components/InlineNotification';

const DEFAULT_NOTIFICATION_DURATION = 15_000;

export interface NotificationItem {
  id: string;
  variant: InlineNotificationVariant;
  title: string;
  description?: string;
  duration: number;
}

interface PushNotificationParams {
  variant?: InlineNotificationVariant;
  title: string;
  description?: string;
  duration?: number;
}

class NotificationService {
  notifications: NotificationItem[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  push(params: PushNotificationParams): string {
    const id = uuidv4();
    this.notifications.push({
      id,
      variant: params.variant ?? 'success',
      title: params.title,
      description: params.description,
      duration: params.duration ?? DEFAULT_NOTIFICATION_DURATION,
    });
    return id;
  }

  remove(id: string): void {
    this.notifications = this.notifications.filter((n) => n.id !== id);
  }

  success(title: string, description?: string, duration?: number): string {
    return this.push({ variant: 'success', title, description, duration });
  }

  error(title: string, description?: string, duration?: number): string {
    return this.push({ variant: 'error', title, description, duration });
  }

  warning(title: string, description?: string, duration?: number): string {
    return this.push({ variant: 'warning', title, description, duration });
  }
}

export const notificationService = new NotificationService();
